module.exports = __webpack_public_path__ + "img/Feature-6.85c27e2.svg";